import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'dva';
import { useLocation, history } from 'umi';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import ManagementGiftForm from './components/ManagementGiftForm';
import { OPT_DETAIL } from '@/constants';
import ManagementGiftFormStyles from './managementGiftFormStyles';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id, opt, sourceOid } = query;
  const { handleSubmit, control, setValue, watch, getValues, errors } =
    useForm();
  const watchAllFields = watch();
  const [isSubmit, setIsSubmit] = useState(false);
  const [couponInfo, setCouponInfo] = useState();
  const [openDialog, setOpenDialog] = useState();
  const [openRuleDialog, setOpenRuleDialog] = useState(false);
  const saveRef = useRef();
  //提交成功
  const handleSubmitSuccess = (data) => {
    if (isSubmit) {
      return false;
    }

    setIsSubmit(true);
    const values = id
      ? {
          ...data,
          id,
          couponInfo,
        }
      : {
          ...data,
          couponInfo,
        };
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      params: { ...values }, // 事件公参
    });

    console.log(values, 'values');
    dispatch({
      type: 'managementGiftForm/editManagementGiftForm',
      payload: {
        values,
      },
      callback: (res) => {
        if (res?.code === 0) {
          window.message.toast({
            type: 'success',
            message: id ? '编辑成功' : '新增成功',
            title: '成功',
          });
          setTimeout(() => history.goBack(), 2000);
        } else {
          setIsSubmit(false);
        }
      },
    });
  };
  //提交失败
  const handleSubmitFail = () => {
    setIsSubmit(false);
  };
  useEffect(() => {
    if (!id) {
      return false;
    }
    dispatch({
      type: 'managementGiftForm/getQueryGiftDetail',
      payload: {
        values: {
          id,
        },
      },
      callback: () => {},
    });
  }, [id, dispatch]);

  // 获取会员等级列表
  useEffect(() => {
    dispatch({ type: 'luckDrawViewSetting/getLevels' });
  }, [dispatch]);
  return (
    <ManagementGiftFormStyles>
      <Box
        data-log={JSON.stringify({
          oid: 'page_point_mall_shelf_management_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
            source: sourceOid,
          },
          events: ['_pv', '_pd'],
        })}
        height="100%"
      >
        <Box
          borderRadius="12px"
          bgcolor="background.paper"
          pt={3}
          pr={4}
          pb={4}
          pl={4}
        >
          <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
            <ManagementGiftForm
              control={control}
              setValue={setValue}
              watch={watch}
              watchAllFields={watchAllFields}
              getValues={getValues}
              errors={errors}
              couponInfo={couponInfo}
              setCouponInfo={setCouponInfo}
            />
            <Box display="flex" gap="0 16px" pt={6}>
              {opt !== OPT_DETAIL && (
                <>
                  <Button
                    variant="contained"
                    className="coupons-setting-button"
                    startIcon={
                      <DoneIcon sx={{ width: '16px', height: '16px' }} />
                    }
                    onClick={() => {
                      if (!watch('rule') || watch('rule').length === 0) {
                        setOpenRuleDialog(true);
                      } else {
                        saveRef.current.click();
                      }
                    }}
                  >
                    完成
                  </Button>
                  <Button
                    sx={{ display: 'none' }}
                    data-log={JSON.stringify({
                      oid: 'btn_point_mall_shelf_management_edit_finish',
                      events: ['_ev'],
                      params: {
                        initUrl:
                          window.location.origin + window.location.pathname,
                        source: sourceOid,
                      },
                    })}
                    ref={saveRef}
                    variant="contained"
                    className="coupons-setting-button"
                    type="submit"
                    startIcon={
                      <DoneIcon sx={{ width: '16px', height: '16px' }} />
                    }
                  >
                    完成
                  </Button>
                </>
              )}
              <Button
                variant="contained"
                className="coupons-setting-button"
                color="secondary"
                onClick={() => {
                  setOpenDialog(true);
                }}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                退出
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {opt !== OPT_DETAIL
              ? '退出后将不保存设置内容，确定要退出吗？'
              : '确定要退出吗？'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
              history.goBack();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRuleDialog}
        onClose={() => {
          setOpenRuleDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            确定不配置任何礼品兑换规则吗？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenRuleDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenRuleDialog(false);
              saveRef.current.click();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </ManagementGiftFormStyles>
  );
};
